import React, { useCallback } from 'react';
import { Row, Col } from 'antd';

import { IFlat } from '../../common/model/flat.model';
import { IOffice } from '../../common/model/office.model';

import FlatCard from './flatCard';

type Props = {
  flats: IFlat[];
  offices: IOffice[];
  xlSpan?: number;
  cardBackgroundColor?: string;
  focusedCardBackgroundColor?: string;
  focusedFlatIndex?: number;
  parentRef?: any;
  onFlatHover?: (flat: IFlat, index: number) => void;
};

const ResultsSection: React.FC<Props> = ({
  flats,
  offices,
  xlSpan = 24,
  cardBackgroundColor,
  focusedCardBackgroundColor,
  focusedFlatIndex,
  parentRef,
  onFlatHover,
}: Props): JSX.Element => {
  const getFlatOffice = useCallback(
    (flat: IFlat) => offices.find((office) => office.id === flat.officeId),
    [offices]
  );

  let focusedCardBackgroundColor_ = focusedCardBackgroundColor;
  if (!focusedCardBackgroundColor) {
    focusedCardBackgroundColor_ = cardBackgroundColor;
  }
  return (
    <div ref={parentRef}>
      <Row gutter={[32, 32]}>
        {flats.map((flat, i) => {
          const isFocused = i === focusedFlatIndex;
          return (
            <Col key={flat.id} xs={24} xl={xlSpan}>
              <FlatCard
                flat={flat}
                office={getFlatOffice(flat)}
                cardBackgroundColor={
                  isFocused ? focusedCardBackgroundColor_ : cardBackgroundColor
                }
                useCarousel={true}
                onMouseEnter={() => onFlatHover?.(flat, i)}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default ResultsSection;
